import type { CustomBaseQueryError } from '../../../store/types/error'

export default function ErrorMessage({
  error,
  hasAdditionalKey = false,
  isLeft = false,
  className,
}: {
  error: any
  hasAdditionalKey?: boolean
  isLeft?: boolean
  className?: string
}) {
  return (
    <p
      className={
        className ? className : `text-red-500 ${!isLeft && 'text-center'} `
      }
    >
      {hasAdditionalKey
        ? (error as CustomBaseQueryError).data?.message?.message
        : (error as CustomBaseQueryError).data?.message}
    </p>
  )
}
